<template>
  <div>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>State</th>
          <th>License #</th>
          <th>Expire Date</th>
          <th class="w-50s"/>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, ind) in data.values">
          <!-- License State Select -->
          <td>
            <select :name="name + `[` + ind + `][state]`" class="form-control"
                    v-model="item.state"
                    required>
              <option v-for="(state, state_code) in statesList" :value="state_code">
                {{ state }}
              </option>
            </select>
            <input type="hidden" :name="name + `[` + ind + `][id]`" :value="item.id">
          </td>
          <!-- License # Field -->
          <td>
            <input type="text" class="form-control"
                   :name="name + `[` + ind + `][number]`"
                   v-model="item.number">
          </td>
          <!-- Expire Field -->
          <td>
            <div class="date">
              <datepicker
                v-model="item.expire"
                :name="name + `[` + ind + `][expire]`">
              </datepicker>
            </div>
          </td>
          <td>
            <a class="btn btn-danger" @click.prevent="removeLine(ind)"><i class="fa fa-trash"/></a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3">
            <span class="no-results-text" v-if="data.values.length === 0">No results</span>
          </th>
          <th>
            <a id="add-line" class="btn btn-primary" @click.prevent="addLine"><i class="fa fa-plus"/></a>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<style scoped>
  table {
    margin-bottom: 10px;
  }
</style>

<script>

  /**
   *
   * Component to represent dynamic Licenses form.
   *
   *
   *
   * Example:
   *
   * <adjuster-licenses name="license"
   *                    :model-value="{{ old('license') ? collect(old('license'))->toJson() : $value }}"
   *                    :states-list="['AL', 'AZ', ...]">
   * </adjuster-licenses>
   *
   */

  export default {

    props: {
      // Field name
      name: {
        type: String,
        required: true
      },

      // Initial Licenses array, should contain 'id', 'number', 'state', 'expire'
      modelValue: {
        type: Array,
        default: () => {
          return [];
        }
      },

      // Object with states list.
      statesList: {
        type: Object,
        default: () => {
          return {};
        }
      },
    },

    created() {
    },

    data() {
      return {
        data: {
          // Licenses list.
          values: this.modelValue,
        }
      };
    },

    methods: {
      /**
       * Add new row.
       */
      addLine() {
        this.data.values.push({
          id: '',
          state: '',
          number: '',
          expire: '',
        })
      },

      /**
       * Remove row.
       * @param index
       */
      removeLine(index) {
        this.data.values.splice(index, 1);
      },

    },

    computed: {}
  }
</script>
